import React from 'react';

const CopyIcon = props => (
  <svg
    width="9"
    height="10"
    viewBox="0 0 9 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.29297 10H1.5625C0.700912 10 0 9.29909 0 8.4375V3.14453C0 2.28294 0.700912 1.58203 1.5625 1.58203H5.29297C6.15456 1.58203 6.85547 2.28294 6.85547 3.14453V8.4375C6.85547 9.29909 6.15456 10 5.29297 10ZM1.5625 2.36328C1.13174 2.36328 0.78125 2.71378 0.78125 3.14453V8.4375C0.78125 8.86826 1.13174 9.21875 1.5625 9.21875H5.29297C5.72372 9.21875 6.07422 8.86826 6.07422 8.4375V3.14453C6.07422 2.71378 5.72372 2.36328 5.29297 2.36328H1.5625ZM8.41797 7.46094V1.5625C8.41797 0.700912 7.71706 0 6.85547 0H2.51953C2.30377 0 2.12891 0.174866 2.12891 0.390625C2.12891 0.606384 2.30377 0.78125 2.51953 0.78125H6.85547C7.28622 0.78125 7.63672 1.13174 7.63672 1.5625V7.46094C7.63672 7.6767 7.81158 7.85156 8.02734 7.85156C8.2431 7.85156 8.41797 7.6767 8.41797 7.46094Z"
      fill="currentColor"
    />
  </svg>
);

export default CopyIcon;
